import { ErrorHandler, Injectable } from '@angular/core';
import { LogEntry } from '../log/log-entry';
import { LogService } from '../log/log.service';

/**
 * Note: There is no providedIn or providers for this class
 * because it is like a mock service.
 * You must import the ErrorHandlerModule at the app module.
 * The ErrorHandlerModule injects this service as a mock for the built in Angular ErrorHandler.
 */
@Injectable()
export class ErrHandler implements ErrorHandler {
  constructor(
      private LogService: LogService) {}

  handleError(error: Error) {
    const logEntry: LogEntry = new LogEntry(error.message);
    logEntry.stack = error.stack;
    this.LogService.log(logEntry);
    // TODO temporary don't handle known error from Angular Flex
    if (error.message.includes('split')) {
      return;
    }
  }
}
